// =====================================================================
// MobileBottomNav.jsx — Bottom navigation iOS/Android-style (Day 13+)
// =====================================================================
// 5 icone fixed bottom, vizibile DOAR <= 640px.
// Plus pour modulele rare → modal "More" cu lista tile-uri.
// =====================================================================
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.jsx';
import { useIsMobile } from '../hooks/useIsMobile.jsx';
import AppIcon from './AppIcons.jsx';

export default function MobileBottomNav() {
  const { user, can } = useAuth();
  const isMobile = useIsMobile(640);
  const loc = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);

  if (!isMobile || !user) return null;
  // Nu afișa pe login + change-password
  if (loc.pathname === '/login' || loc.pathname === '/change-password') return null;

  // Tile-uri principale fixed = Temps, Congés, Trajets, Plus, Moi
  const mainItems = [
    { name: 'Temps', icon: 'clock', to: '/temps', show: can(['timesheets.read.own', 'timesheets.read.all', 'presence.read.all']) },
    { name: 'Congés', icon: 'leave', to: '/conges', show: can(['leaves.create.own', 'leaves.approve.all']) },
    { name: 'Trajets', icon: 'truck', to: '/trajets', show: can(['trips.read.all', 'trips.complete.assigned']) },
  ].filter(i => i.show);

  // "Plus" = restul module
  const moreItems = [
    { name: 'Prélèvements', icon: 'basket', to: '/prelevements', show: can(['supply_draws.read.own', 'supply_draws.read.all']) },
    { name: 'Printing', icon: 'print', to: '/impressions', show: can(['printing_jobs.read.own', 'printing_jobs.read.all']) },
    { name: 'Inventaire', icon: 'cube', to: '/inventaire', show: can('inventory.read.all') },
    { name: 'Palettes', icon: 'pallet', to: '/palettes', show: can('pallet_tracking.read.all') },
    { name: 'Erreurs', icon: 'alert', to: '/erreurs', show: can('errors.read.own') },
    { name: 'Cahiers de charge', icon: 'cahier', to: '/cahiers-charge', show: true },
    { name: 'Justificatifs', icon: 'med', to: '/certificats-medicaux', show: can('medical_certificates.read') },
    { name: 'Facturation', icon: 'invoice', to: '/facturation', show: can('facturation.read.all') },
    { name: 'Toutes les apps', icon: 'dash', to: '/apps', show: true },
  ].filter(i => i.show);

  const isActive = (to) => loc.pathname === to || loc.pathname.startsWith(to + '/');

  return (
    <>
      <nav className="mobile-bottom-nav">
        {mainItems.map(it => (
          <Link key={it.to} to={it.to} className={`mbn-item ${isActive(it.to) ? 'active' : ''}`}>
            <span className="mbn-icon"><AppIcon name={it.icon} size={22} /></span>
            <span className="mbn-label">{it.name}</span>
          </Link>
        ))}
        <button className="mbn-item mbn-more" onClick={() => setMoreOpen(true)}>
          <span className="mbn-icon">⋯</span>
          <span className="mbn-label">Plus</span>
        </button>
      </nav>

      {moreOpen && (
        <div className="mbn-more-overlay" onClick={() => setMoreOpen(false)}>
          <div className="mbn-more-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="mbn-more-handle" />
            <h3 style={{ fontSize: 15, marginBottom: 14, color: '#1e293b' }}>Plus d'applications</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14 }}>
              {moreItems.map(it => (
                <Link key={it.to} to={it.to} onClick={() => setMoreOpen(false)} style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                  textDecoration: 'none', color: '#1e293b',
                }}>
                  <span style={{
                    width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: '#f1f5f9', borderRadius: 12,
                  }}>
                    <AppIcon name={it.icon} size={26} />
                  </span>
                  <span style={{ fontSize: 10, textAlign: 'center', lineHeight: 1.2 }}>{it.name}</span>
                </Link>
              ))}
            </div>
            <button onClick={() => setMoreOpen(false)} style={{
              marginTop: 16, width: '100%', padding: 12,
              background: '#f1f5f9', border: 'none', borderRadius: 8,
              fontSize: 13, fontWeight: 600, color: '#475569',
            }}>Fermer</button>
          </div>
        </div>
      )}
    </>
  );
}
